import { Component, Input, OnInit } from '@angular/core';
import { OmniDashboard } from 'src/app/my-sedgwick';
import { BaseComponent } from 'src/app/shared';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-new-claims-card',
    template: `
    <app-panel
      title="New Claims"
      [labelTemplate]="details"
      [headerLevel]="2"
      class="tw-cursor-pointer"
      (click)="FeatureLogging('NewClaims', 'New Claims', 'Summary View Card')"
      routerLink="/summary/new-claims"
      [canExpand]="false"
      tabindex="-1"
      >
      <ng-template #details>
        <div class="tw-w-full tw-flex tw-justify-end">
          @if (omniDashboard) {
            <a
              class="tw-flex tw-items-center"
              aria-label="Go to New claims details page"
              routerLink="/summary/new-claims"
              >
              <div class="app-pr1 tw-text-[var(--sed-dynamic-black-color)] ">
                {{ 'DETAILS' | translation: translationRequest }}
              </div>
            </a>
          }
        </div>
      </ng-template>
      <div class="container">
        <app-loading-panel
          [error]="error"
          [state]="omniDashboard ? 'Loaded' : 'Loading'"
          loadingStyle="Dot"
          >
          <ng-template #content>
            <div class="tw-flex tw-justify-center tw-items-center app-pt3">
              <div class="tw-text-center tw-font-bold">
                <div class="tw-text-[18px] tw--mb-9">{{ 'TODAY' | translation: translationRequest }}</div>
                <div
                  class="tw-text-[140px] tw-text-[var(--sed-black-80-color)]"
                  >
                  {{ omniDashboard.newClaimsToday }}
                </div>
              </div>
            </div>
            <div class="tw-flex tw-justify-center tw-items-center app-pb3 ">
              <div class="tw-text-center tw-font-bold app-pr2">
                <div class="tw-text-[13px] tw--mb-3">{{ 'LAST 7 DAYS' | translation: translationRequest }}</div>
                <div class="tw-text-[40px] tw-text-[var(--sed-black-80-color)]">
                  {{ omniDashboard.newClaims7Days }}
                </div>
              </div>
    
              <div class="tw-text-center tw-font-bold">
                <div class="tw-text-[13px] tw--mb-3">{{ 'LAST 30 DAYS' | translation: translationRequest }}</div>
                <div class="tw-text-[40px] tw-text-[var(--sed-black-80-color)]">
                  {{ omniDashboard.newClaims30Days }}
                </div>
              </div>
            </div>
          </ng-template>
        </app-loading-panel>
      </div>
    </app-panel>
    `,
    styles: [
        `
      .container {
        height: 345px;
      }
    `,
    ],
    standalone: false
})
export class NewClaimsCardComponent extends BaseComponent implements OnInit {
  @Input()
  omniDashboard: OmniDashboard;

  @Input()
  error: any;

  @Input()
  translationRequest: TranslationRequest;
  
  constructor() {
    super();
  }

  ngOnInit(): void {
    return;
  }
}
